function oldShopifyLogout(path){
  var shopLogout = new XMLHttpRequest();
  shopLogout.open('GET', domains.shop_url + '/account/logout');
  shopLogout.onloadstart = function() {
    eraseCookie(logoutCookie, '/', 'gohunt.com');
    // clearCart();
    window.location.href = path;
  };

  shopLogout.send();
}
var logoutCookie = 'gh_logout';
var cookies = getCookies();


async function shopifyLogout() {
  cookies = getCookies();
  if (cookies[logoutCookie] && currentCustomer) {    
    console.log('hitting if statment in shopifyLogout ')
    const shopLogoutUrl = domains.shop_url + '/account/logout'
    eraseCookie(logoutCookie, '/', 'gohunt.com');
    // await clearCart()
    
    return setTimeout(() => {
      currentCustomer = null
      location.href = shopLogoutUrl                  
    }, 1000)
  }
}

(async function() {
  await shopifyLogout();
})();


